
import React, { useMemo, useState } from 'react'
import './tablebase.css'

const TableBase = ({ columns, rows }) => {
  const [sortField, setSortField] = useState(null)
  const [sortDirection, setSortDirection] = useState('asc')
  const [currentPage, setCurrentPage] = useState(1)

  const rowsPerPage = 10

  const handleSort = field => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortField(field)
      setSortDirection('asc')
    }

    setCurrentPage(1)
  }

  const sortedRows = useMemo(() => {
    if (!rows) return []
    if (!sortField) return rows

    return [...rows].sort((a, b) => {
      const valueA = a[sortField]
      const valueB = b[sortField]

      if (valueA == null) return 1
      if (valueB == null) return -1

      const textA = String(valueA).toLowerCase()
      const textB = String(valueB).toLowerCase()

      if (textA < textB) {
        return sortDirection === 'asc' ? -1 : 1
      }

      if (textA > textB) {
        return sortDirection === 'asc' ? 1 : -1
      }

      return 0
    })
  }, [rows, sortField, sortDirection])

  const getPageNumbers = () => { if (totalPages <= 7) { return Array.from({ length: totalPages }, (_, index) => index + 1) } if (currentPage <= 4) { return [1, 2, 3, 4, 5, '...', totalPages] } if (currentPage >= totalPages - 3) { return [ 1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages ] } return [ 1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages ] }
  const totalPages = Math.ceil(sortedRows.length / rowsPerPage)

  const paginatedRows = sortedRows.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  )

  const handlePrevious = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1))
  }

  const handleNext = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages))
  }

  const handlePageChange = page => {
    setCurrentPage(page)
  }

  return (
    <div className="data-table-wrapper">

      <table className="data-table">
        <thead>
          <tr>
            {columns.map(column => (
              <th
                key={column.field}
                onClick={() => handleSort(column.field)}
                style={{ width: column.width }}
              >
                <span>{column.label}</span>

                <span className="sort-icon">
                  {sortField === column.field
                    ? sortDirection === 'asc'
                      ? ' ↑'
                      : ' ↓'
                    : ''}
                </span>
              </th>
            ))}
          </tr>
        </thead>

      <tbody>
  {paginatedRows.map((row, rowIndex) => {
   

    return (
      <tr key={row.id ?? rowIndex}>
        {columns.map(column => (
   <td key={column.field}>
  {column.field === 'cv' ? (
    <a
      href={row.cv.props.href}
      download
      style={{
        color: '#0000ee',
        textDecoration: 'underline',
        cursor: 'pointer'
      }}
    >
      {row.cv.props.children}
    </a>
  ) : (
    row[column.field]
  )}
</td>
        ))}
      </tr>
    )
  })}
</tbody>
      </table>

     {totalPages > 1 && (
  <div className="table-pagination">

    <button
      className="pagination-arrow"
      onClick={handlePrevious}
      disabled={currentPage === 1}
      aria-label="Página anterior"
    >
      ‹
    </button>

    {getPageNumbers().map((page, index) =>
      page === '...' ? (
        <span
          key={`ellipsis-${index}`}
          className="pagination-ellipsis"
        >
          …
        </span>
      ) : (
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          className={currentPage === page ? 'active' : ''}
        >
          {page}
        </button>
      )
    )}

    <button
      className="pagination-arrow"
      onClick={handleNext}
      disabled={currentPage === totalPages}
      aria-label="Página siguiente"
    >
      ›
    </button>

  </div>
)}
    </div>
  )
}

export default TableBase

